<template>
  <div
    class="kk-radio-button-group"
    role="radiogroup"
    v-bind="$attrs"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'KkRadioButtonGroup',
};
</script>

<script setup>
import { isVue2 } from 'vue-demi';
import { computed } from 'vue';

import { RADIO_BUTTON_ITEM_SIZE_LIST } from '../../../constants/KkRadioButtonGroup.constants';
import { useProvideRadioButtonGroupContext } from '../../hooks/useRadioButtonGroupContext';

const props = defineProps({
  /** vue2 */
  value: {
    type: [String, Number, Boolean],
    default: null,
  },
  /** vue3 */
  modelValue: {
    type: [String, Number, Boolean],
    default: null,
  },
  size: {
    type: String,
    default: 'md',
    /** @param {string} val */
    validator(val) {
      return RADIO_BUTTON_ITEM_SIZE_LIST.includes(val);
    },
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits([
  /** vue2 */
  'input',
  /** vue3 */
  'update:modelValue',
  /** onChange 時的事件 */
  'change',
]);

useProvideRadioButtonGroupContext({
  size: computed(() => props.size),
  isDisabled: computed(() => props.isDisabled),
  value: computed(() => {
    if (isVue2) {
      return props.value;
    } else {
      return props.modelValue;
    }
  }),
  /**
   * @param {string|number|boolean|null} value
   */
  onChange: (value) => {
    if (isVue2) {
      emit('input', value);
    } else {
      emit('update:modelValue', value);
    }

    emit('change', value);
  },
});
</script>
